import { Button, FormControl, FormHelperText, Grid, Input, InputLabel } from "@material-ui/core";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { FC, Props, useState } from "react";

interface HomeProps {
  setToken: any;
}

const Home : FC<HomeProps> = props => {

  return  <div style={{ margin: '15%', textAlign: 'center' }} >
     <Grid container spacing={6}>
      <form>
      <Grid item xs={12}>
      <FormControl>
        <InputLabel htmlFor="my-input">Email address</InputLabel>
 
        <Input id="my-input" aria-describedby="my-helper-text" onChange={e => {props.setToken(e.target.value); localStorage.setItem('username', e.target.value)}} />
        <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
      </FormControl>
      </Grid>
      <Grid item xs={12}>

      <Link to="/record">
        <Button variant="contained" color="primary"> Start recording</Button>
      </Link>
      </Grid>
    </form>
    </Grid>
  </div>
   
}


export default Home;